module.exports = __webpack_public_path__ + "static/media/envelop-front.31eb26e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/envelop-front.png
// module id = 7580
// module chunks = 0